import { render, staticRenderFns } from "./changeHighSetting.vue?vue&type=template&id=326cadaf&scoped=true&"
import script from "./changeHighSetting.vue?vue&type=script&lang=js&"
export * from "./changeHighSetting.vue?vue&type=script&lang=js&"
import style0 from "./changeHighSetting.vue?vue&type=style&index=0&id=326cadaf&scoped=true&lang=less&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "326cadaf",
  null
  
)

export default component.exports